const utils = require('frontend-controller/lib/utils')

module.exports = {
    config: {
        showSlim: false,
        heartbeatRefreshOn: {
            'reconnect': true,
            'resourceChanged.bo_status': true
        }
    },

    model: {
        loadedStatusIDs: {}, // stores all statusIDs loaded to determine if a refresh is necessary when heartbeat wants to refresh specific statusIDs.
        modalOpen: false, // this flag is used to determine if the modal is shown at the moment to prevent heartbeats from refreshing if so.
        triggerHeartbeat: null, // if a heartbeat has been triggered during an open modal here it will be stored for later execution.
        parentEntityForStatus: null, // TODO: DOCS
    },

    events: {
        open: {
            type: 'click',
            action(event){
                const self = event.data.component

                event.stopImmediatePropagation()

                self.showEdit('statusFlags', 'project')
            }
        }
    },

    methods: {
        getResourceFilters: function(storage, resourceFilters, actionKey, fieldCode){
            resourceFilters = resourceFilters || {}

            if(actionKey === 'refreshResources'){
                if(utils.collectionSize(this.model.resourceFilters) > 0){
                    utils.refReplace(resourceFilters, this.model.resourceFilters);
                }

                if(!this.model.parentEntityForStatus){
                    this.model.parentEntityForStatus = this.getResourceRegisterContent('parentEntityForStatus') || false
                }
                if(this.model.parentEntityForStatus){
                    utils.refMerge(resourceFilters, {
                        baseFilters:    this.model.parentEntityForStatus.baseFilters || {},
                    })
                }

                this.model.resourceFilters = resourceFilters;
            }

            return resourceFilters;
        },

        sanitizeResources(){
            this.model.loadedStatusIDs = (((this.resourceData.data || {}).attributes || {}).statusFlagsSummary || {}).statusIDs || {}
        },

        /**
         * is at least of the given statusIDs loaded
         * @param statusIDs     object - {<statusID>: true, ...}
         * @returns {boolean}
         */
        isAtLeastOneStatusIDLoaded(statusIDs){
            for(const statusID in statusIDs || {}){
                if((this.model.loadedStatusIDs || {})[statusID]){
                    return true
                }
            }

            return false
        },

        showEdit(buttonContext, buttonMode){
            let baseActionKey = `showEdit_${buttonContext}`
            if(this.config.showSlim){
                baseActionKey += '_slim'
            }
            const actionKey = `${baseActionKey}_inEffect`

            this.model.modalOpen = true

            this.performAndStoreAction(
                actionKey,
                this.prepareAction(baseActionKey, undefined, undefined, {
                    source: {
                        load: {
                            componentData: {
                                model: {
                                    titleKey: `modal.${baseActionKey}.${buttonMode}.title`
                                }
                            }
                        }
                    }
                })
            )
        },

        onHeartbeat(message, heartbeatPrewarmedResourceHashes){
            const refreshers = this.config.heartbeatRefreshOn || {}
            const key = message.heartbeatKey

            if(refreshers[key] && (
                (
                    key !== 'resourceChanged.bo_status'
                ) ||
                (key === 'resourceChanged.bo_status' && this.isAtLeastOneStatusIDLoaded(message.data.statusIDs))
            )){
                // prevent refresh if modal is open to prevent "flickering"
                if(this.model.modalOpen){
                   this.model.triggerHeartbeat = {message, heartbeatPrewarmedResourceHashes}
                } else {
                    this.refresh()
                }
            }
        },
    },

    hooks: {
        onDecision($element, options){
            switch((options.decisionComponent || {}).componentClass) {
                case 'base_modal_modal':
                case 'templates_core_modal_modal':
                    this.model.modalOpen = false
                    if(this.model.triggerHeartbeat){
                        const {
                            message,
                            heartbeatPrewarmedResourceHashes
                        } = this.model.triggerHeartbeat
                        delete this.model.triggerHeartbeat

                        this.onHeartbeat(message, heartbeatPrewarmedResourceHashes)
                    }
                    options.decisionComponent.hide()
                    break;
            }
        }
    },

    handlers: [
        {
            name: 'heartbeat.resourceChanged',
            handle: function(callerComponent, message, heartbeatPrewarmedResourceHashes){
                this.onHeartbeat(message, heartbeatPrewarmedResourceHashes)
            }
        },
        {
            name: 'heartbeat.reconnect',
            handle: function(callerComponent, message, heartbeatPrewarmedResourceHashes){
                this.onHeartbeat(message, heartbeatPrewarmedResourceHashes)
            }
        },
    ],
}